import { getReference } from "@luciad/ria/reference/ReferenceProvider";
import { createBounds } from "@luciad/ria/shape/ShapeFactory";
import { OGCAPIMapsCapabilitiesLayer } from "./OGCAPIMapsCapabilitiesLayer";

const webMercatorReference = getReference("EPSG:3857");

export class OGCAPIMapsCapabilities {

  useVectorTiles(selected: boolean) {
    this._layers.forEach(layer => {
      layer._useVectorTiles = selected;
    });
  }

  _layers: OGCAPIMapsCapabilitiesLayer[] = [];

  private constructor(layers: OGCAPIMapsCapabilitiesLayer[]) {
    this._layers = layers;
  };

  static fromURL(url: string): Promise<OGCAPIMapsCapabilities> {
    return new Promise(function (myResolve, myReject) {
      fetch(url += "?f=json")
        .then(res => res.json())
        .then(out => {
          // console.log('Checkout this JSON! ', out);

          let layers: OGCAPIMapsCapabilitiesLayer[] = [];
          const collections = out.collections;
          collections.forEach((element: { crs: any; extent: any; links: any; id: string; title: string; }) => {

            const layerId = element.id;
            const layerTitle = element.title;

            let layerUrl = "";
            element.links.forEach((link: { rel: string; href: string; }) => {
              if (link.rel === "http://www.opengis.net/def/rel/ogc/1.0/map") {
                layerUrl = link.href;
              }
            });

            if (layerUrl === "") {
              // element.links.forEach((link: { rel: string; href: string; }) => {
              //   if (link.rel === "self") {
              //     layerUrl = link.href.replace("?f=json", "") + "/map";
              //   }
              // });
              layerUrl = url + "/" + layerId + "/map";
            }

            layerUrl = layerUrl.replace("?f=json", "").replace("?f=html", "");

            if (layerUrl.startsWith("/")) {
              layerUrl = new URL(url).origin + layerUrl;
            }

            const x = element.extent.spatial.bbox[0][0];
            const y = element.extent.spatial.bbox[0][1];
            const width = element.extent.spatial.bbox[0][2] - x;
            const height = element.extent.spatial.bbox[0][3] - y;
            const layerBounds = createBounds(getReference("CRS:84"), [x, width, y, height]);

            const bboxCrs = element.crs[0];

            layers[layers.length] = new OGCAPIMapsCapabilitiesLayer(layerId, layerTitle, layerUrl, layerBounds, bboxCrs);
          });

          myResolve(new OGCAPIMapsCapabilities(layers));
        })
        .catch(error => {
          myReject("Could not fetch capabilities");
        });
    });
    ;
  };

  get layers(): OGCAPIMapsCapabilitiesLayer[] {
    return this._layers;
  }

}